// @flow

import React from 'react'
import SvgIcon from './SvgIcon'
import svg from 'material-design-icons/toggle/svg/production/ic_check_box_outline_blank_24px.svg'

type Props = {
  size?: number,
  color?: string,
  style?: Object,
}

export default function UncheckedBox ({size = 24, color = 'rgb(0, 0, 0)', style = {}}: Props): React.Element<any> {
  return (
    <SvgIcon
      size={size}
      color={color}
      src={svg}
      style={style}
    />
  )
}
